<ion-header>
  <ion-toolbar color="secondary">
    <ion-title>MASIVO</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="modalCtrl.dismiss()">
        <ion-icon slot="icon-only" name="close-circle"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <h4>
    Desde esta pantalla vas a poder introducir un valor para los usuarios de este listado a la vez. Ten en
    cuenta que si alguno ya tenía un valor, será reemplazado.
  </h4>
  @if (rutina === 'comida') {
    <div class="comidas ion-margin-top">
      <div class="button-bar">
        <ion-button mode="md" color="dark" fill="solid" (click)="save('primero', '')">
          Primero
        </ion-button>
        <ion-button mode="md" color="success" [fill]="fill('primero', 'Bien')"
                    (click)="save('primero', 'Bien')">
          BIEN
        </ion-button>
        <ion-button mode="md" color="tertiary" [fill]="fill('primero', 'Regular')"
                    (click)="save('primero', 'Regular')">
          REGULAR
        </ion-button>
        <ion-button mode="md" color="danger" [fill]="fill('primero', 'Mal')"
                    (click)="save('primero', 'Mal')">
          MAL
        </ion-button>
      </div>
      <div class="button-bar">
        <ion-button mode="md" color="dark" fill="solid" (click)="save('segundo', '')">
          segundo
        </ion-button>
        <ion-button mode="md" color="success" [fill]="fill('segundo', 'Bien')"
                    (click)="save('segundo', 'Bien')">
          BIEN
        </ion-button>
        <ion-button mode="md" color="tertiary" [fill]="fill('segundo', 'Regular')"
                    (click)="save('segundo', 'Regular')">
          REGULAR
        </ion-button>
        <ion-button mode="md" color="danger" [fill]="fill('segundo', 'Mal')"
                    (click)="save('segundo', 'Mal')">
          MAL
        </ion-button>
      </div>
      <div class="button-bar">
        <ion-button mode="md" color="dark" fill="solid" (click)="save('postre', '')">
          postre
        </ion-button>
        <ion-button mode="md" color="success" [fill]="fill('postre', 'Bien')"
                    (click)="save('postre', 'Bien')">
          BIEN
        </ion-button>
        <ion-button mode="md" color="tertiary" [fill]="fill('postre', 'Regular')"
                    (click)="save('postre', 'Regular')">
          REGULAR
        </ion-button>
        <ion-button mode="md" color="danger" [fill]="fill('postre', 'Mal')"
                    (click)="save('postre', 'Mal')">
          MAL
        </ion-button>
      </div>
      <div class="ion-margin-vertical kblab-flex ion-justify-content-center">
        <ion-button fill="outline" [disabled]="nosavecomida()" (click)="modalCtrl.dismiss(estate)">GUARDAR</ion-button>
      </div>
    </div>
  } @else if (rutina === 'siesta') {
    <div class="siestas">
      <ion-grid>
        <ion-row>
          <ion-col size-md="3" offset-md="3" size-lg="2" offset-lg="4">
            <h4 class="ion-text-center">SIESTA 1</h4>
          </ion-col>
          <ion-col size-md="3" size-lg="2">
            <h4 class="ion-text-center">SIESTA 2</h4>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size-md="6" offset-md="3" size-lg="4" offset-lg="4">
            <div class="linea">
              <ion-row>
                <ion-col>
                  <div class="siestas">
                    <ion-button color="primary" (click)="siesta('i1')">{{estate.i1}}</ion-button>
                    <span class="gap">-</span>
                    <ion-button color="primary" (click)="siesta('f1')" [disabled]="estate.i1 === 'INICIO'">
                      {{estate.f1}}
                    </ion-button>
                  </div>
                </ion-col>
                <ion-col>
                  <div class="siestas">
                    <ion-button color="primary" (click)="siesta('i2')" [disabled]="estate.f1 === 'FINAL'">
                      {{estate.i2}}
                    </ion-button>
                    <span class="gap">-</span>
                    <ion-button color="primary" (click)="siesta('f2')" [disabled]="estate.i2 === 'INICIO'">
                      {{estate.f2}}
                    </ion-button>
                  </div>
                </ion-col>
              </ion-row>
            </div>
          </ion-col>
        </ion-row>
        <ion-row class="ion-margin-vertical kblab-flex ion-justify-content-center">
          <ion-button expand="block" fill="outline" [disabled]="nosavesiesta()" (click)="modalCtrl.dismiss(estate)">
            GUARDAR
          </ion-button>
        </ion-row>
      </ion-grid>
    </div>
  } @else {
    <div class="button-bar">
      <ion-button mode="md" color="dark" fill="solid" (click)="save(rutina, '')">
        {{rutina}}
      </ion-button>
      <ion-button mode="md" color="success" [fill]="fill(rutina, 'Bien')"
                  (click)="save(rutina, 'Bien')">
        BIEN
      </ion-button>
      <ion-button mode="md" color="tertiary" [fill]="fill(rutina, 'Regular')"
                  (click)="save(rutina, 'Regular')">
        REGULAR
      </ion-button>
      <ion-button mode="md" color="danger" [fill]="fill(rutina, 'Mal')"
                  (click)="save(rutina, 'Mal')">
        MAL
      </ion-button>
    </div>
    <div class="ion-margin-vertical kblab-flex ion-justify-content-center">
      <ion-button fill="outline" [disabled]="nosaveresto()" (click)="modalCtrl.dismiss(estate)">
        GUARDAR
      </ion-button>
    </div>
  }
</ion-content>
